module.exports = __webpack_public_path__ + "img/filtro.0b4659dd.svg";